import ReactMarkdown from 'react-markdown';

type ReactMarkdownProps = React.ComponentProps<typeof ReactMarkdown>;

import { cn } from 'lib/utils/cn';
import { Link } from 'modules/i18n';
import React from 'react';

type MarkdownProps = ReactMarkdownProps & {
  // TODO
};

const components: ReactMarkdownProps['components'] = {
  a: ({ children, href }) => {
    if (href?.startsWith('/')) {
      return <Link href={href}>{children}</Link>;
    }
    return (
      <a href={href} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  },
  p: ({ children }) => <div className="whitespace-pre-wrap">{children}</div>,
};

const Markdown: React.FC<MarkdownProps> = ({ children, className, ...props }) => {
  return (
    <ReactMarkdown className={cn('', className)} components={components} {...props}>
      {children}
    </ReactMarkdown>
  );
};

export default Markdown;
